const state = {
  stepList: [],
  isMixed: false,
  lowPlate: 1,
  highPlate: 100,
  minPlate: 0,
  maxPlate: 200,
  geometry: {}
};

export default state;
